import React, { useRef, useState } from "react";
import InputLayout from "./InputLayout";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import { Password } from "primereact/password";
import { Calendar } from "primereact/calendar";
import { InputSwitch } from "primereact/inputswitch";
import { capitalizeCamelCase } from "../utils/commonFunctions";
import { InputOtp } from "primereact/inputotp";
import { MultiSelect } from "primereact/multiselect";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import "react-phone-input-2/lib/style.css";
import { AutoComplete } from "primereact/autocomplete";
import { NumericFormat } from "react-number-format";
import { InputTextarea } from "primereact/inputtextarea";
import { Rating } from "primereact/rating";
import EuroIcon from "assets/images/svg/euroIcon.svg"

export const CustomInput = ({
  label,
  name,
  data,
  value,
  onChange,
  errorMessage,
  extraClassName,
  required,
  col = 6,
  inputClass,
  disabled = false,
  type = "text",
  placeholder = "",
  spanLabel,
  ignoreLabel,
  isSearch,
  ...props
}) => {
  return (
    <InputLayout
      col={col}
      label={label}
      name={name}
      required={required}
      extraClassName={extraClassName}
      data={data}
      errorMessage={errorMessage}
      ignoreLabel={ignoreLabel}
    >
      <div className="input-box ">
        <InputText
          id={name}
          name={name}
          value={value || data?.[name] || ""}
          type={type}
          onChange={(e) =>
            onChange &&
            onChange({ ...e, name: e.target.name, value: e.target.value })
          }
          className={`input w-full ${inputClass ? inputClass : ""} ${errorMessage ? "p-invalid" : ""
            }`}
          placeholder={placeholder || `Enter ${capitalizeCamelCase(name)}`}
          disabled={disabled}
          {...props}
        />
        {isSearch && <i className="pi pi-spin pi-spinner" />}
        {spanLabel && <span className="p-inputgroup-addon">{spanLabel}</span>}
      </div>
    </InputLayout>
  );
};

export const CustomAmountInput = ({
  label,
  name,
  data,
  value,
  onChange,
  errorMessage,
  extraClassName,
  required,
  col = 6,
  inputClass,
  disabled = false,
  type = "text",
  placeholder = "",
  spanLabel,
  ignoreLabel,
  spanExtraClassName,
  spanIcon,
  ignoreIcon,
  ...props
}) => {
  return (
    <InputLayout
      col={col}
      label={label}
      name={name}
      required={required}
      extraClassName={extraClassName}
      data={data}
      errorMessage={errorMessage}
      ignoreLabel={ignoreLabel}
    >
      <div className={`p-inputgroup flex w-full `}>
        <NumericFormat
          value={value || data?.[name]}
          thousandSeparator="."
          decimalSeparator=","
          decimalScale={2}
          fixedDecimalScale={true}
          allowNegative={false}
          onValueChange={(e) => {
            onChange && onChange({ ...e, name: name, value: e.value })
            // if (onChange) {
            //   if (number(e.value)) {
            //     onChange({ ...e, name: name, value: e.value });
            //   } else if (!e.value) {
            //     onChange({ ...e, name: name, value: e.value });
            //   }
            // }
          }}
          // prefix="₹"
          className={`input border-1 numeric_input w-full  ${inputClass ? inputClass : "mb-1"
            } ${errorMessage ? "p-invalid" : ""}`}
          placeholder={placeholder || `Enter ${capitalizeCamelCase(name)}`}
          disabled={disabled}
        />
        {spanLabel && (
          <span
            className={`p-inputgroup-addon ${spanExtraClassName ? spanExtraClassName : ""
              }`}
          >
            {spanLabel}
          </span>
        )}

        {!ignoreIcon && (
          <span
            className={`p-inputgroup-addon ${spanExtraClassName ? spanExtraClassName : ""
              }`}
          >
            {spanIcon ? <img src={spanIcon} /> : <img src={EuroIcon} />}
          </span>
        )}
      </div>
    </InputLayout>
  );
};

export const CustomFileInput = ({
  label,
  name,
  data,
  value,
  onChange,
  errorMessage,
  extraClassName,
  required,
  col = 6,
  inputClass,
  disabled = false,
  type = "text",
  placeholder = "",
  inputKey,
  selectedFiles,
  accept,
  ...props
}) => {
  return (
    <InputLayout
      col={col}
      label={label}
      name={name}
      required={required}
      extraClassName={extraClassName}
      data={data}
      errorMessage={errorMessage}
    >
      {/* <InputText
        id={name}
        name={name}
        type={type}
        onChange={(e) =>
          onChange &&
          onChange({ ...e, name: e.target.name, value: e.target.files[0] })
        }
        className={`input w-full ${inputClass ? inputClass : ""} ${
          errorMessage ? "p-invalid" : ""
        }`}
        placeholder={placeholder || `Enter ${capitalizeCamelCase(name)}`}
        disabled={disabled}
        {...props}
        multiple={true}
        accept=".png, .jpg, .jpeg"
      /> */}
      <input
        disabled={disabled}
        key={inputKey}
        id="file-upload"
        type="file"
        accept={accept || ".jpg,.jpeg,.png,.pdf,.doc,.xls,.zip"}
        onChange={onChange}
        onClick={(event) => {
          if (
            event.target.files.length === 1 &&
            event.target.files[0].name ===
            selectedFiles[selectedFiles.length - 1]?.name
          ) {
            event.target.value = null;
          }
        }}
      // multiple
      />
    </InputLayout>
  );
};

export const CustomPhoneInput = ({
  label,
  name,
  data,
  value,
  onChange,
  errorMessage,
  extraClassName,
  required,
  col = 6,
  inputClass,
  disabled,
  type = "text",
  placeholder = "",
  ignoreLabel,
  ...props
}) => {
  return (
    <InputLayout
      col={col}
      label={label}
      name={name}
      required={required}
      extraClassName={extraClassName}
      data={data}
      errorMessage={errorMessage}
      ignoreLabel={ignoreLabel}
    >
      <PhoneInput
        enableSearch
        disabled={disabled}
        id={name}
        name={name}
        defaultCountry="DE"
        placeholder={placeholder || `Enter ${capitalizeCamelCase(name)}`}
        value={value || data[name]}
        className={`input w-full phone-input ${inputClass ? inputClass : ""} ${errorMessage ? "p-invalid" : ""
          }`}
        onChange={(value) => {
          onChange({ name: name, value: value });
        }}
      />{" "}
    </InputLayout>
  );
};

export const CustomPassword = ({
  label,
  name,
  data,
  value,
  onChange,
  errorMessage,
  extraClassName,
  required,
  col = 12,
  inputClass,
  disabled = false,
  placeholder = "",
  ...props
}) => {
  return (
    <InputLayout
      col={col}
      label={label}
      name={name}
      required={required}
      extraClassName={extraClassName}
      data={data}
      errorMessage={errorMessage}
    >
      <Password
        id={name}
        name={name}
        value={value || data?.[name] || ""}
        onChange={(e) =>
          onChange &&
          onChange({ ...e, name: e.target.name, value: e.target.value })
        }
        className={` ${inputClass ? inputClass : ""} ${errorMessage ? "p-invalid" : ""
          }`}
        disabled={disabled}
        feedback={false}
        toggleMask
        placeholder={placeholder || `Enter ${capitalizeCamelCase(name)}`}
        {...props}
      />
    </InputLayout>
  );
};

export const CustomDropDown = ({
  label,
  name,
  onChange,
  data,
  value,
  errorMessage,
  extraClassName,
  required,
  col = 6,
  optionLabel = "name",
  placeholder = "",
  multiple,
  ignoreLabel,
  colors,
  ...props
}) => {
  const selectedValueTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <div className={getStatusClass(option?.name)}>{option.name}</div>
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };

  const getStatusClass = (status) => {
    if (colors) {
      switch (status) {
        case "Initiated":
        case "New":
          return "text-red-600";

        case "Back Office":
          return "text-yellow-500";

        case "Social Worker":
          return "text-blue-600";

        case "Follow-up":
          return "text-orange-500";

        case "Fixed":
        case "Pending":
          return "text-green-600";

        case "Handyman":
          return "text-cyan-500";

        default:
          return "";
      }
    } else {
      return "";
    }
  };

  const OptionsTemplate = (option) => {
    return (
      <div className="flex align-items-center">
        <div className={getStatusClass(option?.name)}>{option.name}</div>
      </div>
    );
  };

  return (
    <InputLayout
      col={col}
      label={label}
      name={name}
      required={required}
      extraClassName={extraClassName}
      data={data}
      errorMessage={errorMessage}
      ignoreLabel={ignoreLabel}
    >
      <Dropdown
        id={name}
        name={name}
        value={value || data?.[name]}
        onChange={(e) =>
          onChange && onChange({ ...e, name: e.target.name, value: e.value })
        }
        className={`w-full custom-dropdown ${errorMessage ? "p-invalid" : ""}`}
        optionLabel={optionLabel}
        placeholder={placeholder || `Select ${capitalizeCamelCase(name)}`}
        valueTemplate={selectedValueTemplate}
        itemTemplate={OptionsTemplate}
        {...props}
      // filter
      />
    </InputLayout>
  );
};

export const CustomAutoComplete = ({
  label,
  name,
  onChange,
  data,
  value,
  errorMessage,
  extraClassName,
  required,
  col = 6,
  optionLabel = "name",
  placeholder = "",
  multiple,
  ignoreLabel,
  suggestions,
  search,
  onClick,
  max,
  onLazyLoad,
  ...props
}) => {
  return (
    <InputLayout
      col={col}
      label={label}
      name={name}
      required={required}
      extraClassName={extraClassName}
      data={data}
      errorMessage={errorMessage}
      ignoreLabel={ignoreLabel}
    >
      <AutoComplete
        name={name}
        value={value || data?.[name]}
        suggestions={suggestions}
        completeMethod={search}
        inputClassName="w-full"
        className={`w-full custom-dropdown ${errorMessage ? "p-invalid" : ""}`}
        onChange={(e) =>
          onChange && onChange({ ...e, name: e.target.name, value: e.value })
        }
        {...props}
        placeholder={placeholder || `Enter ${capitalizeCamelCase(name)}`}
        maxLength={max}
      // virtualScrollerOptions={{ lazy: true, showLoader: true, itemSize: 10, onLazyLoad: onLazyLoad && onLazyLoad }}
      />
    </InputLayout>
  );
};

export const CustomMulitSelect = ({
  label,
  name,
  onChange,
  data,
  value,
  errorMessage,
  extraClassName,
  required,
  col = 6,
  optionLabel = "name",
  placeholder = "",
  multiple,
  ignoreLabel,
  options,
  ...props
}) => {
  return (
    <InputLayout
      col={col}
      label={label}
      name={name}
      required={required}
      extraClassName={extraClassName}
      data={data}
      errorMessage={errorMessage}
      ignoreLabel={ignoreLabel}
    >
      <MultiSelect
        id={name}
        name={name}
        value={value || data?.[name]}
        onChange={(e) =>
          onChange && onChange({ ...e, name: e.target.name, value: e.value })
        }
        options={options}
        placeholder={placeholder || `Select ${capitalizeCamelCase(name)}`}
        maxSelectedLabels={3}
        className={`w-full custom-dropdown ${errorMessage ? "p-invalid" : ""}`}
        optionLabel={optionLabel}
      />
    </InputLayout>
  );
};

export const CustomCalander = ({
  label,
  name,
  data,
  value,
  onChange,
  errorMessage,
  extraClassName,
  required,
  col = 6,
  inputClass,
  disabled = false,
  placeholder = "",
  ignoreLabel,
  ...props
}) => {
  const calendarRef = useRef(null);

  const handleIconClick = () => {
    if (calendarRef.current) {
      calendarRef.current.focus(); // Focus the calendar to open it
    }
  };

  return (
    <InputLayout
      col={col}
      label={label}
      name={name}
      required={required}
      extraClassName={extraClassName}
      data={data}
      errorMessage={errorMessage}
      ignoreLabel={ignoreLabel}
    >
      <div className="calendar-box">
        <Calendar
          id={name}
          name={name}
          value={value || data?.[name] || ""}
          onChange={(e) => onChange && onChange({ ...e, name, value: e.value })}
          className={`w-full ${inputClass ? inputClass : ""}`}
          disabled={disabled}
          placeholder={placeholder || `Select ${capitalizeCamelCase(name)}`}
          ref={calendarRef}
          {...props}
        />
        <i
          className="pi pi-calendar"
          onClick={handleIconClick}
          style={{ cursor: "pointer" }}
        />
      </div>
    </InputLayout>
  );
};

export const CustomYearInput = ({
  label,
  name,
  data,
  value,
  onChange,
  errorMessage,
  extraClassName,
  required,
  col = 6,
  inputClass,
  disabled = false,
  placeholder = "",
  ignoreLabel,
  ...props
}) => {
  const calendarRef = useRef(null);

  const handleIconClick = () => {
    if (calendarRef.current) {
      calendarRef.current.focus(); // Focus the calendar to open it
    }
  };

  return (
    <InputLayout
      col={col}
      label={label}
      name={name}
      required={required}
      extraClassName={extraClassName}
      data={data}
      errorMessage={errorMessage}
      ignoreLabel={ignoreLabel}
    >
      <div className="calendar-box">
        <Calendar
          id={name}
          name={name}
          value={value || data?.[name] || ""}
          onChange={(e) => onChange && onChange({ ...e, name, value: e.value })}
          className={`w-full ${inputClass ? inputClass : ""}`}
          disabled={disabled}
          placeholder={placeholder || `Select ${capitalizeCamelCase(name)}`}
          ref={calendarRef}
          {...props}
          view="year"
          dateFormat="yy"
        />
        <i
          className="pi pi-calendar"
          onClick={handleIconClick}
          style={{ cursor: "pointer" }}
        />
      </div>
    </InputLayout>
  );
};

export const CustomTime = ({
  label,
  name,
  data,
  value,
  onChange,
  errorMessage,
  extraClassName,
  required,
  col = 6,
  inputClass,
  disabled = false,
  placeholder = "",
  ignoreLabel,
  ...props
}) => {
  const calendarRef = useRef(null);

  const handleIconClick = () => {
    if (calendarRef.current) {
      calendarRef.current.focus(); // Focus the calendar to open it
    }
  };

  return (
    <InputLayout
      col={col}
      label={label}
      name={name}
      required={required}
      extraClassName={extraClassName}
      data={data}
      errorMessage={errorMessage}
      ignoreLabel={ignoreLabel}
    >
      <div className="calendar-box">
        <Calendar
          id={name}
          name={name}
          value={value || data?.[name] || ""}
          onChange={(e) => onChange && onChange({ ...e, name, value: e.value })}
          className={`w-full ${inputClass ? inputClass : ""}`}
          disabled={disabled}
          placeholder={placeholder || `Select ${capitalizeCamelCase(name)}`}
          ref={calendarRef}
          {...props}
          timeOnly
          hourFormat="12"
          showTime
        />
        <i
          className="pi pi-clock"
          onClick={handleIconClick}
          style={{ cursor: "pointer" }}
        />
      </div>
    </InputLayout>
  );
};

export const CustomCheckbox = ({
  label,
  name,
  data,
  value,
  onChange,
  errorMessage,
  extraClassName,
  required,
  col,
  inputClass,
  template,
  ...props
}) => {
  return (
    <InputLayout
      col={col || 6}
      name=""
      extraClassName={extraClassName}
      errorMessage={data?.formErrors?.[name]}
    >
      <Checkbox
        id={name}
        name={name}
        inputId={label}
        checked={value || data?.[name]}
        onChange={(e) =>
          onChange && onChange({ ...e, name: e.target.name, value: e.checked })
        }
        className={`checkbox ${inputClass ? inputClass : ""} ${errorMessage ? "p-invalid" : ""
          }`}
        {...props}
      />

      {label && (
        <label htmlFor={label} className="ml-2">
          {label}
        </label>
      )}
      {template && <>{template}</>}
    </InputLayout>
  );
};

export const CustomRadioInput = ({
  label,
  name,
  data,
  value,
  onChange,
  errorMessage,
  extraClassName,
  required,
  col,
  inputClass,
  template,
  checked,
  ...props
}) => {
  return (
    <InputLayout
      col={col || 6}
      name=""
      extraClassName={extraClassName}
      errorMessage={data?.formErrors?.[name]}
    >
      <Checkbox
        id={`${name}-${value}`}
        name={name}
        value={value}
        inputId={label}
        checked={checked}
        onChange={(e) =>
          onChange && onChange({ ...e, name: e?.target?.name, value: e.value })
        }
        className={`checkbox ${inputClass ? inputClass : ""} ${errorMessage ? "p-invalid" : ""
          }`}
        {...props}
      />
      {label && (
        <label htmlFor={`${name}-${value}`} className="ml-2">
          {label}
        </label>
      )}
      {template && <>{template}</>}
    </InputLayout>
  );
};

export const CustomSwitch = ({
  label,
  name,
  data,
  value,
  onChange,
  col = 6,
  extraClassName,
  flexClass,
  ...props
}) => {
  return (
    <InputLayout extraClassName={extraClassName} col={col} name="">
      <div className={`flex ${flexClass}`}>
        <InputSwitch
          checked={value || data?.[name]}
          onChange={(e) => onChange && onChange({ ...e, name, value: e.value })}
          {...props}
        />
        <div htmlFor={label} className="ml-2 text-lg my-auto">
          {label ? capitalizeCamelCase(label) : label}
        </div>
      </div>
    </InputLayout>
  );
};

//New
export const CustomSearch = ({
  name,
  data,
  value,
  onChange,
  isSearch,
  placeholder,
}) => {
  return (
    <div className="search-box">
      <InputText
        id={name}
        className="w-full"
        placeholder={placeholder || "Search"}
        name={name}
        value={value || data?.[name] || ""}
        onChange={(e) =>
          onChange &&
          onChange({ ...e, name: e.target.name, value: e.target.value })
        }
      />
      {!isSearch ? (
        <i className="pi pi-search" />
      ) : (
        <i className="pi pi-spin pi-spinner" />
      )}
    </div>
  );
};

export const CustomOtpInput = ({
  label,
  name,
  data,
  value,
  onChange,
  errorMessage,
  extraClassName,
  required,
  col = 12,
  inputClass,
  disabled = false,
  type = "text",
  placeholder = "",
  ...props
}) => {
  return (
    <InputLayout
      col={col}
      label={label}
      name={name}
      extraClassName={extraClassName}
      data={data}
      errorMessage={errorMessage}
    >
      <InputOtp
        integerOnly
        length={6}
        value={value || data?.[name] || ""}
        name={name}
        onChange={(e) =>
          onChange && onChange({ ...e, name: name, value: e?.value })
        }
      />
    </InputLayout>
  );
};

export const CustomAddSubtractInput = ({
  label,
  name,
  data,
  // value,
  onChange,
  errorMessage,
  extraClassName,
  required,
  col = 6,
  inputClass,
  disabled = false,
  type = "text",
  placeholder = "",
  ...props
}) => {
  const [value, setValue] = useState(0);

  return (
    <InputLayout
      col={col}
      label={label}
      name={name}
      required={required}
      extraClassName={extraClassName}
      data={data}
      errorMessage={errorMessage}
    >
      <InputText
        id={name}
        name={name}
        value={value || data?.[name] || ""}
        type={type}
        onChange={(e) =>
          onChange &&
          onChange({ ...e, name: e.target.name, value: e.target.value })
        }
        className={`input w-full ${inputClass ? inputClass : ""} ${errorMessage ? "p-invalid" : ""
          }`}
        placeholder={placeholder || `Enter ${capitalizeCamelCase(name)}`}
        disabled={disabled}
        {...props}
      />
    </InputLayout>
  );
};

export const CustomForm = ({ children, title, header, col, extraClassName, titleCol, formClass }) => {
  return (
    <form className={`${formClass} ${formClass} grid m-0 p-0 justify-content-between overflow-hidden w-full `}>
      {title ? <div className={`col-12 lg:col-${titleCol || '10'} title my-auto ${extraClassName}`}>{title}</div> : null}
      {header ? (
        <div className={`col-${col || '2'} title my-auto`}>{header}</div>
      ) : null}
      {children}
    </form>
  );
};

// export const CustomInputMask = ({
//   label,
//   name,
//   data,
//   value,
//   onChange,
//   errorMessage,
//   extraClassName,
//   required,
//   col = 6,
//   inputClass,
//   disabled = false,
//   type = "text",
//   placeholder = "",
//   spanLabel,
//   ignoreLabel,
//   ...props
// }) => {
//   return (
//     <InputLayout
//       col={col}
//       label={label}
//       name={name}
//       required={required}
//       extraClassName={extraClassName}
//       data={data}
//       errorMessage={errorMessage}
//       ignoreLabel={ignoreLabel}
//     >
//       <div className="p-inputgroup flex-1">
//         <InputNumber
//           id={name}
//           name={name}
//           value={value || data?.[name] || 0}
//           type={type}
//           onValueChange={(e) =>
//             onChange && onChange({ ...e, name: e.target.name, value: e.value })
//           }
//           className={`input w-full ${inputClass ? inputClass : ""} ${
//             errorMessage ? "p-invalid" : ""
//           }`}
//           placeholder={placeholder || `Enter ${capitalizeCamelCase(name)}`}
//           disabled={disabled}
//           {...props}
//         />
//         {spanLabel && <span className="p-inputgroup-addon">{spanLabel}</span>}
//       </div>
//     </InputLayout>
//   );
// };

export const CustomInputMask = ({
  label,
  name,
  data,
  value,
  onChange,
  errorMessage,
  extraClassName,
  required,
  col = 6,
  inputClass,
  disabled = false,
  type = "text",
  placeholder = "",
  spanLabel,
  ignoreLabel,
  max,
  ...props
}) => {
  return (
    <InputLayout
      col={col}
      label={label}
      name={name}
      required={required}
      extraClassName={extraClassName}
      data={data}
      errorMessage={errorMessage}
      ignoreLabel={ignoreLabel}
    >
      <div className="p-inputgroup flex-1">
        <InputText
          id={name}
          name={name}
          value={value || data?.[name]}
          type={type}
          onChange={(e) =>
            onChange &&
            onChange({ ...e, name: e.target.name, value: e.target.value })
          }
          className={`input w-full ${inputClass ? inputClass : ""} ${errorMessage ? "p-invalid" : ""
            }`}
          placeholder={placeholder || `Enter ${capitalizeCamelCase(name)}`}
          disabled={disabled}
          maxLength={max}
          {...props}
        />
        {spanLabel && <span className="p-inputgroup-addon">{spanLabel}</span>}
      </div>
    </InputLayout>
  );
};

export const CustomTextArea = ({
  label,
  name,
  data,
  value,
  onChange,
  errorMessage,
  extraClassName,
  required,
  col = 6,
  inputClass,
  disabled = false,
  type = "text",
  placeholder = "",
  spanLabel,
  ignoreLabel,
  isSearch,
  ...props
}) => {
  return (
    <InputLayout
      col={col}
      label={label}
      name={name}
      required={required}
      extraClassName={extraClassName}
      data={data}
      errorMessage={errorMessage}
      ignoreLabel={ignoreLabel}
    >
      <div className="input-box ">
        <InputTextarea
          id={name}
          name={name}
          value={value || data?.[name] || ""}
          type={type}
          rows={5}
          cols={30}
          onChange={(e) =>
            onChange &&
            onChange({ ...e, name: e.target.name, value: e.target.value })
          }
          className={`input w-full p-placeholder ${inputClass ? inputClass : ""} ${errorMessage ? "p-invalid" : ""
            }`}
          placeholder={placeholder || `Enter ${capitalizeCamelCase(name)}`}
          disabled={disabled}
          {...props}
        />
        {isSearch && <i className="pi pi-spin pi-spinner" />}
        {spanLabel && <span className="p-inputgroup-addon">{spanLabel}</span>}
      </div>
    </InputLayout>
  );
};

export const CustomRatings = ({
  label,
  name,
  data,
  value,
  onChange,
  errorMessage,
  extraClassName,
  required,
  col = 6,
  inputClass,
  disabled = false,
  type = "text",
  placeholder = "",
  spanLabel,
  ignoreLabel,
  isSearch,
  ...props
}) => {
  return (
    <InputLayout
      col={col}
      label={label}
      name={name}
      required={required}
      extraClassName={extraClassName}
      data={data}
      errorMessage={errorMessage}
      ignoreLabel={ignoreLabel}
    >
      <div className="input-box ">
        {/* <InputTextarea
          id={name}
          name={name}
          value={value || data?.[name] || ""}
          type={type}
          rows={5} 
          cols={30}
          onChange={(e) =>
            onChange &&
            onChange({ ...e, name: e.target.name, value: e.target.value })
          }
          className={`input w-full ${inputClass ? inputClass : ""} ${
            errorMessage ? "p-invalid" : ""
          }`}
          placeholder={placeholder || `Enter ${capitalizeCamelCase(name)}`}
          disabled={disabled}
          {...props}
        /> */}
        <Rating
          className="custom-rating"
          id={name}
          value={value || data?.[name]}
          onChange={(e) => {
            onChange && onChange({ ...e, name: name, value: e.value });
          }}
          cancel={false}
          {...props}
        />
        {spanLabel && <span className="p-inputgroup-addon">{spanLabel}</span>}
      </div>
    </InputLayout>
  );
};
